import { graphql } from '@api/generated';
import FeatureFlagModule, { FeatureFlagKeys } from '@modules/FeatureFlagModule';

export const getUsersQuery = () => {
  return FeatureFlagModule.isEnabled(FeatureFlagKeys.featureFeUserStatusPhase2)
    ? getUsersAvailabilityActivityQuery
    : getServiceUsersQuery;
};

export const getServiceUsersQuery = graphql(`
  query getServiceUsersQuery {
    users {
      items {
        id
        contactCenterUserId
        name
        email
        available
        status
        stats {
          lastActionAt
          lastHandledAt
          lastIdleAt
          loginAt
          totalSessions
          offeredSessions
          missedSessions
          avgCallTime
        }
        personalLine {
          phoneNumber
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
  }
`);

/*
 * This query is used to fetch the availability activity status of service users.
 * New status availabilityActivityStatus is fetched instead of status,
 * availabilityActivityStatus {
 *  availabilityStatus
 *  activityStatus
 *}
 * This change is part of the feature flag
 * featureFeUserStatusPhase2
 */
export const getUsersAvailabilityActivityQuery = graphql(`
  query getUsersAvailabilityActivityQuery {
    users {
      items {
        id
        contactCenterUserId
        name
        email
        available
        availabilityActivityStatus {
          availabilityStatus
          activityStatus
        }
        stats {
          lastActionAt
          lastHandledAt
          lastIdleAt
          loginAt
          totalSessions
          offeredSessions
          missedSessions
          avgCallTime
        }
        personalLine {
          phoneNumber
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
  }
`);
